// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  animation: fadeIn 0.2s ease-out;
}

.modal-container {
  background-color: white;
  border-radius: 12px;
  width: 100%;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  padding: 20px;
}

.icon-container {
  display: flex;
  justify-content: center;
}

.message-container {
  text-align: center;
}

.message-text {
  color: var(--ion-color-medium);
  margin: 0;
}

.button-container {
  display: flex;
  justify-content: center;
}

.close-button {
  --border-radius: 6px;
  width: 100%;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes slideIn {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
/** Media queries to set font size and spacing based on screen size **/
/*#region Small Screens*/
/* Styles for screens smaller than 800px wide or 550 high */
@media (max-width: 800px) or (max-height: 550px) {
  .icon-container {
    margin-top: 6px;
    margin-bottom: 10px;
  }
  .status-icon {
    font-size: 40px;
  }
  .message-container {
    margin-bottom: 10px;
  }
  .message-text {
    font-size: 12px;
  }
  .button-container {
    margin-top: 12px;
  }
}
/*#endregion Small Screens*/
/*#region Medium Screens*/
/* Styles for medium screens with min with of 800px and min height of 550px */
@media (min-width: 800px) and (min-height: 550px) {
  .icon-container {
    margin-top: 8px;
    margin-bottom: 14px;
  }
  .status-icon {
    font-size: 50px;
  }
  .message-container {
    margin-bottom: 15px;
  }
  .message-text {
    font-size: 14px;
  }
  .button-container {
    margin-top: 16px;
  }
}
/*#endregion Medium Screens*/
/*#region Larger Screens*/
/* Styles for screens larger than 1000px wide and 600px high */
@media (min-width: 1000px) and (min-height: 600px) {
  .icon-container {
    margin-top: 10px;
    margin-bottom: 16px;
  }
  .status-icon {
    font-size: 64px;
  }
  .message-container {
    margin-bottom: 20px;
  }
  .message-text {
    font-size: 16px;
  }
  .button-container {
    margin-top: 20px;
  }
}
/*#endregion Larger Screens*/`, "",{"version":3,"sources":["webpack://./src/app/components/http-response-modal/http-response-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,+BAAA;AACF;;AAGA;EACE,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,yCAAA;EACA,aAAA;AAAF;;AAIA;EACE,aAAA;EACA,uBAAA;AADF;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,8BAAA;EACA,SAAA;AADF;;AAIA;EACE,aAAA;EACA,uBAAA;AADF;;AAIA;EACE,oBAAA;EACA,WAAA;AADF;;AAIA;EACE;IAAO,UAAA;EAAP;EACA;IAAK,UAAA;EAEL;AACF;AAAA;EACE;IAAO,4BAAA;IAA8B,UAAA;EAIrC;EAHA;IAAK,wBAAA;IAA0B,UAAA;EAO/B;AACF;AALA,sEAAA;AAEA,wBAAA;AAEE,2DAAA;AACA;EACE;IACE,eAAA;IACA,mBAAA;EAKJ;EAFE;IACE,eAAA;EAIJ;EADE;IACE,mBAAA;EAGJ;EAAE;IACE,eAAA;EAEJ;EACE;IACE,gBAAA;EACJ;AACF;AAEA,2BAAA;AAEA,yBAAA;AAEE,6EAAA;AACA;EACE;IACE,eAAA;IACA,mBAAA;EAFJ;EAKE;IACE,eAAA;EAHJ;EAME;IACE,mBAAA;EAJJ;EAOE;IACE,eAAA;EALJ;EAQE;IACE,gBAAA;EANJ;AACF;AAQA,4BAAA;AAEA,yBAAA;AAEE,8DAAA;AACA;EACE;IACE,gBAAA;IACA,mBAAA;EARJ;EAWE;IACE,eAAA;EATJ;EAYE;IACE,mBAAA;EAVJ;EAaE;IACE,eAAA;EAXJ;EAcE;IACE,gBAAA;EAZJ;AACF;AAcA,4BAAA","sourcesContent":[".modal-backdrop {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 2000;\r\n  animation: fadeIn 0.2s ease-out;\r\n}\r\n\r\n// Remove .modal-backdrop since Ionic will provide its own backdrop\r\n.modal-container {\r\n  background-color: white;\r\n  border-radius: 12px;\r\n  width: 100%;\r\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);\r\n  padding: 20px;\r\n}\r\n\r\n// Rest of your CSS remains the same\r\n.icon-container {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.message-container {\r\n  text-align: center;\r\n}\r\n\r\n.message-text {\r\n  color: var(--ion-color-medium);\r\n  margin: 0;\r\n}\r\n\r\n.button-container {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.close-button {\r\n  --border-radius: 6px;\r\n  width: 100%;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from { opacity: 0; }\r\n  to { opacity: 1; }\r\n}\r\n\r\n@keyframes slideIn {\r\n  from { transform: translateY(-20px); opacity: 0; }\r\n  to { transform: translateY(0); opacity: 1; }\r\n}\r\n\r\n/** Media queries to set font size and spacing based on screen size **/\r\n\r\n/*#region Small Screens*/\r\n\r\n  /* Styles for screens smaller than 800px wide or 550 high */\r\n  @media (max-width: 800px) or (max-height: 550px) {\r\n    .icon-container {\r\n      margin-top: 6px;\r\n      margin-bottom: 10px;\r\n    }\r\n\r\n    .status-icon {\r\n      font-size: 40px;\r\n    }\r\n\r\n    .message-container {\r\n      margin-bottom: 10px;\r\n    }\r\n\r\n    .message-text {\r\n      font-size: 12px;\r\n    }\r\n\r\n    .button-container {\r\n      margin-top: 12px;\r\n    }\r\n  }\r\n\r\n/*#endregion Small Screens*/\r\n\r\n/*#region Medium Screens*/\r\n\r\n  /* Styles for medium screens with min with of 800px and min height of 550px */\r\n  @media (min-width: 800px) and (min-height: 550px) {\r\n    .icon-container {\r\n      margin-top: 8px;\r\n      margin-bottom: 14px;\r\n    }\r\n\r\n    .status-icon {\r\n      font-size: 50px;\r\n    }\r\n\r\n    .message-container {\r\n      margin-bottom: 15px;\r\n    }\r\n\r\n    .message-text {\r\n      font-size: 14px;\r\n    }\r\n\r\n    .button-container {\r\n      margin-top: 16px;\r\n    }\r\n  }\r\n/*#endregion Medium Screens*/\r\n\r\n/*#region Larger Screens*/\r\n\r\n  /* Styles for screens larger than 1000px wide and 600px high */\r\n  @media (min-width: 1000px) and (min-height: 600px) {\r\n    .icon-container {\r\n      margin-top: 10px;\r\n      margin-bottom: 16px;\r\n    }\r\n\r\n    .status-icon {\r\n      font-size: 64px;\r\n    }\r\n\r\n    .message-container {\r\n      margin-bottom: 20px;\r\n    }\r\n\r\n    .message-text {\r\n      font-size: 16px;\r\n    }\r\n\r\n    .button-container {\r\n      margin-top: 20px;\r\n    }\r\n  }\r\n/*#endregion Larger Screens*/"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
